import Vue from "vue";
import R from "ramda";

Vue.filter("cnpj", (value, type) => {
  const formater = {
    digito: () => value.substring(12, 14),
    raiz: () => {
      return `${value.substring(0, 2)}.${value.substring(2, 5)}.${value.substring(
        5,
        8,
      )}/${value.substring(8, 12)}`;
    },
  };

  if (!R.isNil(value)) {
    if (value.length === 14) {
      return formater[type]();
    }
  }
  return "Invalid CNPJ";
});
